import React, { Fragment, useState } from "react";
import { StyledButton } from "../../../components/ListShowButton";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles,
} from "@material-ui/core";
import {
  Button,
  useMutation,
  useNotify,
  useRefresh,
} from "react-admin";
import SaveIcon from "@material-ui/icons/Save";

interface IDeleteButton {
  id: number;
  status?: "Pending" | "Approved" | "Rejected";
}

const useStyles = makeStyles({
  dialog: {
    "& .MuiDialog-paper": {
      overflowY: "unset",
    },
  },
});

const CustomConfirmButton = ({id}: IDeleteButton) => {
  const refresh = useRefresh();
  const notify = useNotify();

  const [handleDelete, { loading }] = useMutation(
    {
      type: "customDelete",
      resource: `subcontractorAdhocFees/${id}/delete`,
      payload: {},
    },
    {
      onSuccess: () => {
        notify(`Successfully delete adhoc fee.`, "info");
        refresh();
      },
      onFailure: (error) =>
        notify(`Failed delete adhoc fee, error: ${error.message}`, "warning"),
    }
  );

  return (
    <Button
      onClick={handleDelete}
      color="primary"
      label={loading ? "Please wait..." : "Confirm"}
      autoFocus
    >
      <SaveIcon />
    </Button>
  );
}

const DeleteButton = ({id, status}: IDeleteButton) => {
  const [open, setOpen] = useState<boolean>(false);

  const classes = useStyles();

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      <StyledButton
        variant="outlined"
        onClick={handleOpenDialog}
        style={{ color: "#f44336", borderColor: "#f44336" }}
      >
        Delete
      </StyledButton>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title">Delete The Adhoc Fee</DialogTitle>
        <DialogContent>
          <DialogContentText color="initial">
            Are you sure you want to delete the adhoc fee?
            <br/>
            {status === "Approved" &&
              "If you delete this approved adhoc fee, the record will not appear " +
              "on the subcontractor purchase invoice."}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" label="Back" />
          <CustomConfirmButton id={id} />
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}

export default DeleteButton;